import "@/css/components/avatar.scss";
import { assertNotNull } from "@enymo/ts-nullsafe";
import React from "react";
import route from "ziggy-js";
import { User } from "../resources";
import { Avatar } from "./Avatar";

export function UserAvatar({
    className,
    sid,
    size,
    user
}: {
    className?: string,
    sid?: string,
    size: number,
    user: Pick<User, "id" | "has_avatar" | "first_name" | "last_name" | "avatar_version">
}) {
    assertNotNull(user, "User must be logged in");

    return (
        <Avatar
            className={className}
            size={size}
            src={user.has_avatar ? route("users.avatar.show", { user: user.id, sid, v: user.avatar_version }) : undefined}
            initials={`${user.first_name[0]}${user.last_name[0]}`}
        />
    )
}
